import { render, staticRenderFns } from "./DocumentsEducation.vue?vue&type=template&id=0fc14d78"
import script from "./DocumentsEducation.vue?vue&type=script&lang=js"
export * from "./DocumentsEducation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports